import React from 'react';
import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface AddContractButtonProps {
    onClick: () => void;
}

export const AddContractButton: React.FC<AddContractButtonProps> = ({ onClick }) => {
    return (
        <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onClick}
            sx={{
                backgroundColor: '#162346',
                color: 'white',
                fontWeight: 600,
                px: 3,
                py: 1,
                '&:hover': {
                    backgroundColor: '#1a2a52'
                }
            }}
        >
            Add Contract
        </Button>
    );
};
